/*
  Customima · Favoritos (lista de deseos)
  - Guarda las joyas en este navegador (localStorage), sin pedir nada.
  - Avisa a Connectif con el formulario oculto #cm-fav-evento (Connectif escucha los
    formularios de la web por su id y manda el evento «formulario enviado»).
  - Pide el email con #cm-fav-form (tira inferior y página de favoritos).
  Documentación: ConnectIf/lista-deseos/README.md
*/
(function () {
  'use strict';

  var KEY = 'cm_favoritos_v1';
  var KEY_EMAIL = 'cm_fav_email';          // ya nos dejó el email por aquí
  var KEY_CLOSED = 'cm_fav_tira_cerrada';  // cerró la tira (fecha)
  var DIAS_SIN_TIRA = 7;

  var root = document.getElementById('cm-fav-root');
  if (!root) return;

  function getLS(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function setLS(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }

  function load() {
    try { var l = JSON.parse(getLS(KEY)); return Array.isArray(l) ? l : []; } catch (e) { return []; }
  }
  function save(l) { setLS(KEY, JSON.stringify(l)); }
  function indexOf(l, id) { for (var i = 0; i < l.length; i++) if (String(l[i].id) === String(id)) return i; return -1; }
  function handles(l) { return l.map(function (p) { return p.handle; }).join(','); }

  function isKnown() {
    if (root.getAttribute('data-known') === '1') return true;
    if (getLS(KEY_EMAIL) === '1') return true;
    try {
      var info = window.connectif && window.connectif.getClientInfo && window.connectif.getClientInfo();
      if (info && info.primaryKey) return true;
    } catch (e) {}
    return false;
  }

  function favUrl() {
    var r = root.getAttribute('data-root') || '/';
    return (r === '/' ? '' : r) + '/pages/favoritos';
  }

  /* ---------- Connectif ---------- */
  function sendToConnectif() {
    try {
      var cn = window.connectif, m = cn && cn.managed;
      if (!m || !m.isInitialized || !m.isInitialized()) return;
      m.getAllConnectifEventsAsync().then(function (ev) {
        if (!ev || !ev.length) return;
        m.sendEvents(ev, {
          onResponded: function () {
            // Ya enviado: que no se repita al cargar la siguiente página
            ['cn_last_submitted_form_id', 'cn_last_submitted_form_data', 'cn_last_submitted_form_primary_key_field']
              .forEach(function (k) { try { cn.unset(k); } catch (e) {} });
          }
        });
      });
    } catch (e) {}
  }

  function fillProduct(form, p, list) {
    function set(name, v) { var i = form.querySelector('[name="' + name + '"]'); if (i) i.value = v || ''; }
    set('producto_id', p ? p.id : '');
    set('producto_url', p ? p.url : '');  // ruta: /products/... (los emails la usan con /discount/)
    set('producto_titulo', p ? p.title : '');
    set('producto_imagen', p && p.image ? (p.image.indexOf('//') === 0 ? 'https:' + p.image : p.image) : '');
    set('producto_precio', p ? p.price : '');
    set('favoritos', handles(list));
  }

  function submitQuiet(form) {
    // Lanza el evento submit (Connectif lo captura) sin navegar
    if (form.requestSubmit) form.requestSubmit();
    else form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
  }

  /* ---------- Interfaz ---------- */
  var toastTimer;
  function toast(html) {
    var t = document.querySelector('.cm-fav-toast');
    if (!t) return;
    t.innerHTML = html;
    t.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.hidden = true; }, 3500);
  }

  function refresh() {
    var l = load();
    document.querySelectorAll('[data-cm-fav]').forEach(function (b) {
      var on = indexOf(l, b.getAttribute('data-id')) > -1;
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      b.setAttribute('aria-label', on ? 'Quitar de favoritos' : 'Guardar en favoritos');
    });
    document.querySelectorAll('.cm-fav-count').forEach(function (c) {
      c.textContent = l.length;
      c.hidden = l.length === 0;
    });
    document.querySelectorAll('.cm-fav-header').forEach(function (a) { a.classList.toggle('has-items', l.length > 0); });
    if (root.getAttribute('data-page') === '1') renderPage(l);
  }

  function stripClosedRecently() {
    var t = parseInt(getLS(KEY_CLOSED), 10);
    return t && (Date.now() - t) < DIAS_SIN_TIRA * 864e5;
  }

  function showStrip(p, list) {
    var s = document.querySelector('.cm-fav-strip');
    if (!s) return false;
    var form = s.querySelector('#cm-fav-form');
    if (form) fillProduct(form, p, list);
    s.querySelector('[data-cm-fav-step="form"]').hidden = false;
    s.querySelector('[data-cm-fav-step="ok"]').hidden = true;
    s.hidden = false;
    document.documentElement.classList.add('cm-fav-strip-open');
    return true;
  }

  function hideStrip(s) {
    s.hidden = true;
    document.documentElement.classList.remove('cm-fav-strip-open');
  }

  function onHeart(btn) {
    var l = load();
    var p = {
      id: btn.getAttribute('data-id'),
      handle: btn.getAttribute('data-handle'),
      title: btn.getAttribute('data-title'),
      url: btn.getAttribute('data-url'),
      image: btn.getAttribute('data-image'),
      price: btn.getAttribute('data-price'),
      t: Date.now()
    };
    var i = indexOf(l, p.id);
    if (i > -1) {
      l.splice(i, 1);
      save(l);
      refresh();
      toast('<span>Quitada de tus favoritos</span>');
      return;
    }
    l.unshift(p);
    save(l);
    refresh();
    btn.classList.add('is-pop');
    setTimeout(function () { btn.classList.remove('is-pop'); }, 180);

    // Aviso a Connectif: qué joya se guardó
    var ev = document.getElementById('cm-fav-evento');
    if (ev) {
      ev.querySelector('[name="accion"]').value = 'guardar';
      fillProduct(ev, p, l);
      submitQuiet(ev);
    }

    if (!isKnown() && !stripClosedRecently() && showStrip(p, l)) return;
    toast('<span>Guardada en tus favoritos</span><a href="' + favUrl() + '">Ver</a>');
  }

  /* ---------- Página de favoritos ---------- */
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  function renderPage(l) {
    var list = document.querySelector('[data-cm-fav-list]');
    if (!list) return;
    list.innerHTML = l.map(function (p) {
      return '<div class="cm-fav-item">' +
        '<a href="' + esc(p.url) + '"><img src="' + esc(p.image) + '" alt="" loading="lazy" width="88" height="88"></a>' +
        '<div class="cm-fav-item__info"><a class="cm-fav-item__title" href="' + esc(p.url) + '">' + esc(p.title) + '</a>' +
        '<span class="cm-fav-item__price">' + esc(p.price) + '</span></div>' +
        '<button type="button" class="cm-fav-item__remove" data-cm-fav-remove="' + esc(p.id) + '" aria-label="Quitar ' + esc(p.title) + ' de favoritos">' +
        '<svg aria-hidden="true" width="16" height="16" viewBox="0 0 24 24" fill="none"><path d="M6 6l12 12M18 6 6 18" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg></button>' +
        '</div>';
    }).join('');
    var empty = document.querySelector('[data-cm-fav-empty]');
    if (empty) empty.hidden = l.length > 0;
    var box = document.querySelector('[data-cm-fav-box]');
    if (box) {
      box.hidden = l.length === 0 || isKnown();
      var form = box.querySelector('#cm-fav-form');
      if (form) fillProduct(form, l[0], l);
    }
  }

  function money(cents) {
    try { return (cents / 100).toLocaleString('es-ES', { style: 'currency', currency: 'EUR' }); } catch (e) { return ''; }
  }

  // Desde los emails: /pages/favoritos?f=handle1,handle2 recupera la lista en otro dispositivo
  function restoreFromUrl() {
    var m = location.search.match(/[?&]f=([^&]+)/);
    if (!m) return Promise.resolve();
    var wanted = decodeURIComponent(m[1]).split(',').filter(Boolean).slice(0, 30);
    var l = load();
    var have = l.map(function (p) { return p.handle; });
    var r = root.getAttribute('data-root') || '/';
    var base = r === '/' ? '' : r;
    return Promise.all(wanted.filter(function (h) { return have.indexOf(h) === -1; }).map(function (h) {
      return fetch(base + '/products/' + encodeURIComponent(h) + '.js').then(function (res) { return res.ok ? res.json() : null; }).catch(function () { return null; });
    })).then(function (prods) {
      prods.forEach(function (pr) {
        if (!pr) return;
        l.push({
          id: String(pr.id), handle: pr.handle, title: pr.title, url: pr.url,
          image: pr.featured_image ? pr.featured_image + (pr.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=400' : '',
          price: money(pr.price), t: Date.now()
        });
      });
      save(l);
    });
  }

  /* ---------- Eventos ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-cm-fav]');
    if (b) { e.preventDefault(); e.stopPropagation(); onHeart(b); return; }
    var r = e.target.closest('[data-cm-fav-remove]');
    if (r) {
      var l = load(), i = indexOf(l, r.getAttribute('data-cm-fav-remove'));
      if (i > -1) { l.splice(i, 1); save(l); refresh(); }
      return;
    }
    if (e.target.closest('[data-cm-fav-close]')) {
      var s = document.querySelector('.cm-fav-strip');
      if (s) hideStrip(s);
      setLS(KEY_CLOSED, String(Date.now()));
    }
  }, true);

  // 1) Antes que nadie: un email mal escrito no llega a Connectif
  window.addEventListener('submit', function (e) {
    var f = e.target;
    if (f.id !== 'cm-fav-form') return;
    var input = f.querySelector('[name="email"]');
    var err = f.querySelector('.cm-fav-form__error');
    var ok = input && /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(input.value.trim());
    if (err) err.hidden = !!ok;
    if (!ok) {
      e.preventDefault();
      e.stopImmediatePropagation();
      if (input) input.focus();
    } else {
      input.value = input.value.trim().toLowerCase();
    }
  }, true);

  // 2) Después de Connectif (que escucha en el propio formulario): ningún formulario de favoritos navega
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (f.id === 'cm-fav-evento') { e.preventDefault(); sendToConnectif(); return; }
    if (f.id !== 'cm-fav-form') return;
    e.preventDefault();
    var btn = f.querySelector('button[type="submit"]');
    if (btn) btn.disabled = true;
    setLS(KEY_EMAIL, '1');
    sendToConnectif();
    var wrap = f.closest('.cm-fav-strip, [data-cm-fav-box]');
    if (wrap) {
      var formStep = wrap.querySelector('[data-cm-fav-step="form"]');
      var okStep = wrap.querySelector('[data-cm-fav-step="ok"]');
      if (formStep) formStep.hidden = true;
      if (okStep) okStep.hidden = false;
      if (wrap.classList.contains('cm-fav-strip')) setTimeout(function () { hideStrip(wrap); }, 5000);
    }
  });

  // Móvil: abajo a la derecha de la zona del carrusel (como Tous), sin tapar las miniaturas.
  // Ordenador: la galería puede ser una cuadrícula; el ♡ va arriba a la derecha de la PRIMERA foto visible.
  function placeHearts() {
    document.querySelectorAll('[data-cm-fav]').forEach(function (b) {
      var g = b.parentElement;
      if (!g) return;
      if (window.innerWidth < 1000) {
        var list = g.querySelector('.product-gallery__image-list');
        if (!list) return;
        var gr0 = g.getBoundingClientRect(), lr = list.getBoundingClientRect();
        if (!lr.height) return;
        b.style.left = '';
        b.style.right = '12px';
        b.style.bottom = 'auto';
        b.style.top = Math.round(lr.bottom - gr0.top - b.offsetHeight - 12) + 'px';
        return;
      }
      var m = g.querySelector('.product-gallery__media:not([hidden])');
      if (!m) return;
      var gr = g.getBoundingClientRect(), mr = m.getBoundingClientRect();
      if (!mr.width) return;
      b.style.right = 'auto';
      b.style.bottom = 'auto';
      b.style.left = Math.round(mr.right - gr.left - b.offsetWidth - 16) + 'px';
      b.style.top = Math.round(mr.top - gr.top + 16) + 'px';
    });
  }

  function init() {
    restoreFromUrl().then(refresh);
    placeHearts();
    window.addEventListener('load', placeHearts);
    window.addEventListener('resize', placeHearts);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  // El tema vuelve a pintar la ficha al cambiar de variante
  document.addEventListener('variant:change', function () { setTimeout(refresh, 50); });
})();
